import { Component, Input, OnInit} from '@angular/core';
import {LibraryItem} from "../../../model/library";
import {Router} from "@angular/router";
import {ImageService} from "../../../services/image.service";
import {LibraryService} from "../../../services/library.service";

@Component({
  selector: 'booking-item',
  templateUrl: './booking-item.component.html',
  styleUrls: ['./booking-item.component.less']
})
export class BookingItemComponent implements  OnInit {

  @Input()
  bookingItem: LibraryItem;
  imageLink: string;

  constructor(
    private router: Router,
    public imageService: ImageService,
    public libraryService: LibraryService,

  ) {
  }

  ngOnInit(): void {
    this.imageLink = this.bookingItem.mainPhoto ? this.bookingItem.mainPhoto : this.bookingItem.imageLink;
  }


  deleteBookingItem() {
    this.libraryService.removeItemFromBookStorage(this.bookingItem);
  }
}
